const getLevel = (currentStock, minimumStock) => {
  if (!minimumStock || minimumStock <= 0) return "warning";
  const ratio = currentStock / minimumStock;
  return ratio <= 0.5 ? "critical" : "warning";
};
 
const InventoryAlerts = ({ alerts = [], loading }) => {
  return (
    <div className="inventory-alerts-section">
      <div className="section-header">
        <h3>Inventory Stock Alerts</h3>
        <button className="view-all-link">View All</button>
      </div>
 
      <div className="alerts-list">
        {loading && <p>Loading alerts...</p>}
 
        {!loading && alerts.length === 0 && <p>No stock alerts right now.</p>}
 
        {!loading &&
          alerts.map((item, index) => {
            const level = getLevel(item.currentStock, item.minimumStock);
 
            return (
              <div key={item.id ?? index} className={`alert-item ${level}`}>
                <div className="alert-content">
                  <h4>{item.name || item.materialName}</h4>
                  <p>
                    Stock: <strong>{item.currentStock}</strong> units
                    (Threshold: {item.minimumStock})
                  </p>
                </div>
                <div className={`alert-indicator ${level}`}>
                  {level === "critical" ? "!" : "⚠"}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
 
export default InventoryAlerts;
 














